import { exists } from '@/helpers/utilities';

export let mixin = () => {
	let state = {
		input: document.querySelector('#search-input'),
		clearBtn: document.getElementById('clear-btn')
	};
	
	let module = {
		init() {
			if (exists(state.input) && exists(state.clearBtn)) {
				this.bindEvents();
			}
		},

		bindEvents() {
			state.clearBtn.addEventListener('click', () => {
				state.input.value = '';
				state.input.focus();
				state.input.dispatchEvent(new Event('input'));
			});
		}
	};

	return module.init();
};

export default {
	init() {
		return mixin();
	},
};
